import styled from "styled-components";
import { Button } from "primereact/button";
import { theme } from "styles/theme";

export const DisableOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${theme.colors.secondaryTransparent};
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TableContainer = styled.div<{ $editing?: boolean }>`
  position: relative;
  border-radius: ${theme.borderRadius.small};
  outline: ${(props) =>
    props.$editing ? `2px solid ${theme.colors.tertiaryTransparent}` : "none"};
  outline-offset: 4px;
  transition: outline-color 0.2s ease;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1rem;

  .p-button {
    min-height: 44px;
  }
`;

export const ParamsHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
`;

export const StatusRefreshButton = styled(Button)`
  width: 2.25rem;
  height: 2.25rem;
  min-width: 44px;
  min-height: 44px;
  padding: 0;
  flex-shrink: 0;
  margin-right: auto;
  color: ${theme.colors.textSecondary} !important;

  .p-button-icon {
    font-size: 0.95rem;
    color: inherit;
  }

  &:enabled:hover {
    color: ${theme.colors.textPrimary} !important;
    background: ${theme.colors.bgLight} !important;
  }

  &.is-refreshing .p-button-icon {
    animation: status-refresh-spin 1s linear infinite;
  }

  @keyframes status-refresh-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ParamsToolbarHint = styled.span`
  font-size: 0.75rem;
  color: ${theme.colors.textSecondary};
  line-height: 1.2;
`;

export const ParamCellSlot = styled.div`
  display: flex;
  align-items: center;
  min-height: 2.5rem;
  width: 100%;
`;

export const ParamValueSlot = styled.span`
  display: inline-flex;
  align-items: center;
  min-height: 2.5rem;
  min-width: 5.5rem;
  font-variant-numeric: tabular-nums;
  color: ${theme.colors.textPrimary};
`;

export const ParamInputWrap = styled.div<{ $variant?: "number" | "dropdown" }>`
  display: inline-flex;
  align-items: center;
  min-height: 2.5rem;
  min-width: ${(props) =>
    props.$variant === "dropdown" ? "5rem" : "5.5rem"};

  .p-inputnumber {
    width: 5.5rem;
  }

  .p-inputnumber-input {
    min-height: 2.5rem;
    width: 5.5rem;
  }

  .p-dropdown {
    width: 5rem;
    min-height: 2.5rem;
  }

  .p-dropdown .p-dropdown-label {
    display: flex;
    align-items: center;
    padding: 0.5rem 0.25rem 0.5rem 0.65rem;
    overflow: visible;
    text-overflow: clip;
  }

  .p-dropdown .p-dropdown-trigger {
    width: 2rem;
    flex-shrink: 0;
  }
`;

export const ParamConnectionSlot = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-height: 2.5rem;
`;

export const ConnectionToggle = styled.div`
  display: inline-flex;
  padding: 0.15rem;
  border-radius: ${theme.borderRadius.small};
  background-color: ${theme.colors.bgLight};
  border: 1px solid ${theme.colors.border};
  max-width: 100%;
`;

export const ConnectionToggleOption = styled.button<{ $active: boolean }>`
  appearance: none;
  border: none;
  margin: 0;
  padding: 0.35rem 0.55rem;
  min-height: 2rem;
  border-radius: 3px;
  font-size: 0.75rem;
  font-weight: ${(props) =>
    props.$active ? theme.fontWeights.medium : theme.fontWeights.normal};
  font-family: inherit;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background-color: ${(props) =>
    props.$active ? theme.colors.tertiary : "transparent"};
  color: ${(props) =>
    props.$active ? theme.colors.onTertiary : theme.colors.textPrimary};
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover:not(:disabled) {
    background-color: ${(props) =>
      props.$active ? theme.colors.tertiaryDark : theme.colors.surface};
    color: ${(props) =>
      props.$active ? theme.colors.onTertiary : theme.colors.textPrimary};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: none;
    box-shadow: ${theme.colors.focusRing};
  }
`;
